import MrcStoreModel from 'common/models/mrcModel';
import {createState} from './createState';
import {MrcState} from 'containers/MRC/types';
import {
	MrcEntryCreateRequest,
	MrcItem,
	MrcListRequest,
} from 'common/types/store/mrcTypes';

type MrcStoreState = MrcState & {
	resetState: () => void;
	resetQueryResult: () => void;
	resetActiveBrregOrg: () => void;
	resetMrcActiveRow: () => void;
	setActiveMrcRow: (row: MrcItem | null) => void;
	fetchMrcTemplates: () => Promise<void>;
	fetchMrcEntry: (id: number) => Promise<void>;
	fetchMrcList: (params: MrcListRequest) => Promise<void>;
	fetchBrregOrg: (orgNumber: string) => Promise<void>;
	createMrcEntry: (data: MrcEntryCreateRequest, onSuccess?: () => void) => Promise<void>;
};

const useMrcStore = createState<MrcStoreState>('MrcStore', (set) => {
	const model = new MrcStoreModel(set);

	return {
		// Initialize state
		...model.defaultState,
		// State Actions
		resetState: () => model.resetState(),
		resetQueryResult: () => model.resetQueryResult(),
		resetActiveBrregOrg: () => model.resetActiveBrregOrg(),
		resetMrcActiveRow: () => model.resetMrcActiveRow(),
		setActiveMrcRow: (row: MrcItem | null) => model.setActiveMrcRow(row),

		// Api calls
		fetchMrcTemplates: () => model.fetchMrcTemplates(),
		fetchMrcEntry: (id: number) => model.fetchMrcEntry(id),
		fetchMrcList: (params: MrcListRequest) => model.fetchMrcList(params),
		fetchBrregOrg: (orgNumber: string) => model.fetchBrregOrg(orgNumber),
		createMrcEntry: (data: MrcEntryCreateRequest, onSuccess?: () => void) => model.creatMrc(data, onSuccess),
	};
});

export default useMrcStore;